import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HorseRaceWidget from './Widgets/HorseRaceWidget.jsx';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/event/:raceName' element={<HorseRaceWidget />} />
        <Route path='/' element={<HorseRaceWidget />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App;
